// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"BookHandLuggageModalLayout-mobile__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/BookHandLuggageModalLayout/BookHandLuggageModalLayout.mobile.scss
 ** module id = 949
 ** module chunks = 1
 **/